module.exports = __webpack_public_path__ + "media/images/bt-pagar-conta-6af765f08ef62ba1205230fdee068837.svg";